const {default: DatabaseReference} = require('../platform/DatabaseReference');
const {default: Trip} = require('./Trip');

export default class TripCustomer extends DatabaseReference {
  get childReferenceType() {
    return Trip;
  }
}
